var map = {
  "./cs.json": [
    "uV",
    [
      "sh"
    ]
  ],
  "./en.json": [
    "vwE",
    [
      "lqn"
    ]
  ],
  "./pl.json": [
    "xoN",
    [
      "rv"
    ]
  ],
  "./ru.json": [
    "ag",
    [
      "c"
    ]
  ],
  "./tr.json": [
    "DHZ",
    [
      "p8"
    ]
  ],
  "./ja.json": [
    "wfm",
    [
      "a4j"
    ]
  ],
  "./zh.json": [
    "nPn",
    [
      "dj"
    ]
  ],
  "./pt-br.json": [
    "sTH",
    [
      "mio"
    ]
  ],
  "./de.json": [
    "M0",
    [
      "yf"
    ]
  ],
  "./es.json": [
    "rAg",
    [
      "xan"
    ]
  ],
  "./fr.json": [
    "GL",
    [
      "cg"
    ]
  ],
  "./it.json": [
    "cG",
    [
      2
    ]
  ],
  "./ko.json": [
    "sFp",
    [
      "6w"
    ]
  ],
  "./pt.json": [
    "NY",
    [
      "rpo"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "uq";
module.exports = __rspack_async_context;
